<h2 class="usage-summary-title">Usage Summary</h2>

<main class="usage-summary">
  <div class="usage-summary-section">
    <label class="form-input-wrapper">
      <span class="form-input-label">Billing Statement Day of Month:</span>
      <input *ngIf="!isLoading; else statSkeleton" [value]="stats?.daysBeforeSubscriptionEnds" readonly class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <span class="form-input-label">Available Pages Per Statement:</span>
      <input *ngIf="!isLoading; else statSkeleton" [value]="stats?.availablePagesCount" readonly class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <span class="form-input-label">Extra Pages Purchased This Statement:</span>
      <input *ngIf="!isLoading; else statSkeleton" [value]="stats?.extraPagesCount" readonly class="form-input_md" />
    </label>
  </div>

  <div class="usage-summary-section_grid">
    <label class="form-input-wrapper">
      <span class="form-input-label">Faxes Sent This Statement:</span>
      <input *ngIf="!isLoading; else statSkeleton" [value]="stats?.sendFaxesCurrentCount" readonly class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <span class="form-input-label">Total Pages:</span>
      <input *ngIf="!isLoading; else statSkeleton" [value]="stats?.sendFaxesTotalCount" readonly class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <span class="form-input-label">Faxes Received This Statement:</span>
      <input *ngIf="!isLoading; else statSkeleton" [value]="stats?.receiveFaxesCurrentCount" readonly class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <span class="form-input-label">Total Pages:</span>
      <input *ngIf="!isLoading; else statSkeleton" [value]="stats?.receiveFaxesTotalCount" readonly class="form-input_md" />
    </label>
  </div>
</main>

<ng-template #statSkeleton>
  <span class="skeleton form-input-skeleton_md form-input-skeleton"></span>
</ng-template>
